import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean'
})
export class BooleanPipe implements PipeTransform {
  transform(value: boolean, noLabel: string = 'No'): string {
    return value ? 'Yes' : noLabel;
  }
}
